import { ThemeSchemaResponse } from '@api';
import { FollowThemeButton } from '@terminal/components/follow-theme-button/FollowThemeButton';
import { RenderFeatureFlag } from '@terminal/components/render-feature-flag/RenderFeatureFlag';
import { ThemeLogoIcon } from '@terminal/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';
import { useTranslation } from 'react-i18next';

import styles from './ThemeHeaderDetailed.module.scss';

export interface ThemeHeaderDetailedProps {
  theme: Pick<ThemeSchemaResponse, 'id' | 'logo_url' | 'name' | 'description'>;
  title?: string;
}

export const ThemeHeaderDetailed = ({
  theme,
  title,
}: ThemeHeaderDetailedProps) => {
  const { t } = useTranslation(['widget']);

  return (
    <div className={styles.header}>
      <div className={styles.topRow}>
        <div className={styles.headerContent}>
          <ThemeLogoIcon logo_url={theme.logo_url} name={theme.name} />
          <span>
            <div className={styles.titleText}>{title ?? theme.name}</div>
            <div className={styles.subtitleSmall}>
              {t('assetOverview.knowledgeGraph.themeExposure.investmentTheme')}
            </div>
          </span>
        </div>
        <RenderFeatureFlag requiredFlag="followed_themes">
          <FollowThemeButton themeId={theme.id} />
        </RenderFeatureFlag>
      </div>
      <div className={styles.bodySmall}>{theme.description}</div>
    </div>
  );
};
